import { render, staticRenderFns } from "./issueDetail.vue?vue&type=template&id=33f3f53e&"
import script from "./issueDetail.vue?vue&type=script&lang=ts&"
export * from "./issueDetail.vue?vue&type=script&lang=ts&"
import style0 from "./issueDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports